import { gql } from '@eti/schema-types';

export const GET_BEST_PRICES_PER_PERIOD = gql(`
  query bestPricesPerPeriod($destination: String!, $lengthOfStay: Int!, $origin: String!, $periods: [Int!]!) {
    bestPricesPerPeriod(destination: $destination, lengthOfStay: $lengthOfStay, origin: $origin, periods: $periods) {
      bestPricesPerPeriod {
        bounds {
          date
          destination
          origin
        }
        period
        price
        }
      }
    }
`);
